<template>
  <!-- <button class="btn btn-primary btn-sm" type="button" data-bs-toggle="tooltip" data-bs-placement="right" :title="text"><i class="fa-solid fa-circle-question"></i></button> -->
  <span class="icon question-input" :class="styleClass" data-bs-toggle="tooltip" data-bs-placement="right" :title="text" :data-bs-custom-class="customClass"><i class="fa-solid fa-circle-question"></i></span>
</template>

<script>
import { onMounted, watch } from '@vue/runtime-core'
import { useI18n } from 'vue-i18n'
export default {
    props:{
        text: String,
        customClass: String,
        styleClass: String
    },
    setup(props) {
        const { locale } = useI18n()
        onMounted(() => {
            const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            })
            /* const exampleEl = document.getElementById('icon')
            const tooltip = new bootstrap.Tooltip(exampleEl)    */         
        })

        watch(locale, () => {            
            setTimeout(() => {
                const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                })                
            }, 1000) 
        })
    }
}
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }    
    .question-input {
        position: absolute;
        top: 11px;
        right: 10px;
        color: var(--mm-primary);
    }

    .question-mark-inline {
        position: static !important;
    }
</style>